import Layout from "@/components/Layout";
import Hero from "@/sections/Hero";
import Marquee from "@/components/Marquee";
import ChiSiamo from "@/sections/ChiSiamo";
import MenuSection from "@/sections/MenuSection";
import PiattiDelGiorno from "@/sections/PiattiDelGiorno";
import Eventi from "@/sections/Eventi";
import Galleria from "@/sections/Galleria";
import Recensioni from "@/sections/Recensioni";
import Faq from "@/sections/Faq";
import Newsletter from "@/sections/Newsletter";
import Contatti from "@/sections/Contatti";
import { Reveal } from "@/components/Reveal";
import { Check } from "lucide-react";
import { waMenuLink, SITE } from "@/data/site";
import { Phone, MessageCircle } from "lucide-react";

const reasons = [
  "Preparazioni giornaliere",
  "Cucina calda pronta da asporto",
  "Ricette tradizionali e proposte stagionali",
  "Ingredienti selezionati",
  "Piatti adatti alla pausa pranzo e alla cena",
  "Possibilità di prenotare anticipatamente",
  "Soluzioni per famiglie, aziende ed eventi",
  "Servizio attento e professionale",
];

function Perche() {
  return (
    <section className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-terracotta font-medium">Perché scegliere SAPORÉ</p>
          <h2 className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl leading-none tracking-tight text-charred">
            Quando hai poco tempo,<br /><span className="italic text-terracotta">scegli di mangiare bene</span>
          </h2>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-6">
          {reasons.map((r, i) => (
            <Reveal key={r} delay={(i % 4) * 0.06}>
              <div className="flex items-start gap-3">
                <span className="mt-0.5 w-6 h-6 rounded-full bg-olive/15 grid place-items-center text-olive-dark shrink-0">
                  <Check size={13} strokeWidth={3} />
                </span>
                <p className="text-sm md:text-base text-charred/80">{r}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-20 bg-terracotta text-cream rounded-lg p-10 md:p-14 text-center relative overflow-hidden">
          <span aria-hidden="true" className="absolute -top-6 left-6 font-serif italic text-[10rem] leading-none text-cream/10 pointer-events-none select-none">"</span>
          <h3 className="font-serif text-3xl md:text-5xl tracking-tight relative">Il pranzo è pronto.</h3>
          <p className="mt-4 max-w-xl mx-auto text-cream/80 text-sm md:text-base relative">
            Non hai tempo per cucinare? Scegli ciò che preferisci, ritira il tuo ordine e goditi tutto il sapore di una cucina preparata con cura.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-4 relative">
            <a href={SITE.phoneHref} data-testid="cta-call-btn"
              className="inline-flex items-center gap-2 rounded-full bg-cream text-terracotta px-7 py-3.5 text-sm font-semibold hover:-translate-y-0.5 transition-transform duration-300">
              <Phone size={15} /> Prenota telefonicamente
            </a>
            <a href={waMenuLink} target="_blank" rel="noopener noreferrer" data-testid="cta-whatsapp-btn"
              className="inline-flex items-center gap-2 rounded-full border border-cream/50 text-cream px-7 py-3.5 text-sm font-semibold hover:bg-cream/10 hover:-translate-y-0.5 transition-all duration-300">
              <MessageCircle size={15} /> Scrivici su WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <Layout welcome>
      <Hero />
      <Marquee />
      <ChiSiamo />
      <MenuSection />
      <PiattiDelGiorno />
      <Perche />
      <Eventi />
      <Galleria />
      <Recensioni />
      <Faq />
      <Newsletter />
      <Contatti />
    </Layout>
  );
}
